import gql from 'graphql-tag';

export default gql`
  query sendEmail($input: SendEmailInput) {
    sendEmail(input: $input) {
      response
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/queries/sendEmailToMember.js